/** @format */

import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const companyProfile = createAsyncThunk(
  "profile/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/EsignServices/getUserDetails`
      );
      sessionStorage.setItem("username", response.data.username);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState: {
    profileData: {},
    status: STATUSES.IDLE,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(companyProfile.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(companyProfile.fulfilled, (state, action) => {
        state.profileData = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(companyProfile.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
        state.error = action.payload;
      });
  },
});

export default profileSlice.reducer;
